import { render, staticRenderFns } from "./Mdok.vue?vue&type=template&id=68d9614b&"
import script from "./Mdok.vue?vue&type=script&lang=js&"
export * from "./Mdok.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports